import "./index.css";

import { Route, Switch } from "react-router-dom";

import { AuthProvider } from "./contexts/auth";
import { Provider } from "react-redux";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { THEME_CONFIG } from "./configs/AppConfig";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import Views from "./views";
import store from "./redux/store";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};




function App() {

  return (
    <>
      <AuthProvider>
        <Provider store={store}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Router>
              <Switch>
                <Route path="/" component={Views} />
              </Switch>
            </Router>
          </ThemeSwitcherProvider>
        </Provider>
      </AuthProvider>
    </>
  );
}

export default App;
